import { useEffect, useState, useRef } from "react";
import { CloseOutlined } from "@ant-design/icons";
import { useLocalStorageState } from "ahooks";
import general from "../../general";
import Cover from "./Cover";
import Result from "./Result";
import SwiperCore, { Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import Dialog from "../../lib/Dialog";
import $ from "jquery";
import { getKidCallback, userClickReport } from "../../utils/kidCallback";
import dayjs from "dayjs";
import { behaviorTrigger } from "../../utils/trigger";
import { storageLocal } from "../../view/util/storage";

SwiperCore.use([Autoplay]);

export default ({ active, setTitle }) => {
  const [query, setQuery] = useState({
    boardkw: "",
    gamekw: "",
    classifyId: "",
    type: 2,
  });
  const [refresh, setRefresh] = useState("");

  let [isShow, setIsShow] = useState(true);
  let [kws, setKws] = useLocalStorageState("search-kws", {
    defaultValue: [],
  });
  let [swiperIndex, setSwiperIndex] = useState(null);
  const hasLoadedRef = useRef(false);

  useEffect(() => {
    // 如果已经加载过，直接返回
    if (hasLoadedRef.current) {
      return;
    }

    hasLoadedRef.current = true;
    general.axios
      .get("/v3/base/search/index", {
        headers: { username: "" },
      })
      .then((res) => {
        let { status, data } = res.data;
        console.log("搜索页数据", data);
        if (!status.succeed) {
          return;
        }
        kws = data.search_keyword;
        setKws(data.search_keyword);
      })
      .catch((err) => {
        console.log("search " + err.message);
      });
  }, []);

  // 输入搜索词上报
  const searchBtnClick = async () => {
    console.log("分类搜索开始点击", query);

    // 同步生成三级kid
    let kid = await getKidCallback();
    // 点击搜索结果上报时的 父级kid
    sessionStorage.setItem("searchResultParentKid", kid);

    // 行为上报
    // 一级kid、二级kid都进行传递
    let reamrk = {
      search_time: dayjs().unix(),
      search_term: query.boardkw || query.gamekw,
    };
    userClickReport({
      target_action_type: "search",
      parent_id: sessionStorage.getItem("boxSecondKid"),
      kid,
      level: 3,
      action_code: "search_input",
      remark: JSON.stringify(reamrk),
    });
  };

  let clickCount = 0;

  // 点击键盘搜索按钮
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault(); // 避免默认提交

      setQuery({
        gamekw: query.boardkw || query.gamekw,
        boardkw: "",
        classifyId: "",
        type: 2,
      });
      setRefresh({});
      searchBtnClick();
    }
  };

  // 点击搜索按钮
  const btnClickSearch = () => {
    if (swiperIndex) {
      let font = "";
      if (swiperIndex > kws.length) {
        font = kws[swiperIndex - 2];
      } else {
        font = kws[swiperIndex - 1];
      }

      isShow = false;
      setIsShow(false);
      query.boardkw = "";
      query.gamekw = font;
      query.classifyId = "";
      query.type = 2;
      setQuery({
        boardkw: "",
        gamekw: font,
        classifyId: "",
        type: 2,
      });
    }

    setQuery({
      gamekw: query.boardkw || query.gamekw,
      boardkw: "",
      classifyId: "",
      type: 2,
    });
    setRefresh({});

    searchBtnClick();
  };

  useEffect(() => {
    setTitle(
      <div className="search-index-input">
        <div className="search-index-input-left">
          <img
            className="search-index-input-icon"
            src="/resources/common/search.png"
            alt=""
          />

          <div className="search-index-input-main">
            {kws.length > 0 && isShow ? (
              <div className="search-index-input-main-swiper">
                <Swiper
                  autoplay={{
                    delay: 5000,
                  }}
                  key="search-index-input-main-swiper"
                  loop={true}
                  direction="vertical"
                  onTransitionEnd={(data) => {
                    swiperIndex = data.activeIndex;
                    setSwiperIndex(data.activeIndex);
                  }}
                >
                  {kws.map((item, index) => (
                    <SwiperSlide
                      key={index}
                      className="search-index-input-main-swiper-slide"
                    >
                      <div className="search-index-input-main-swiper-slide-text search">
                        {item}
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            ) : null}

            <input
              className="search-index-input-main-input"
              type="text"
              autoFocus
              value={query.boardkw || query.gamekw} //  || query.gamekw
              placeholder={kws.length > 0 ? "" : "请输入关键字搜索"}
              onMouseDown={() => {
                clickCount++;
                if (clickCount > 2) {
                  Dialog.info(
                    <div>
                      若遇到iOS系统键盘问题，请
                      <br />
                      重启手机或我的-&gt;联系客服
                    </div>
                  );
                  clickCount = 0;
                }
              }}
              onFocus={() => {
                if (storageLocal.has("tgm_uuid")) {
                  behaviorTrigger("search");
                }
              }}
              onInput={(e) => {
                sessionStorage.setItem("boardInputFont", e.target.value);

                swiperIndex = null;
                setSwiperIndex(null);
                setQuery({
                  boardkw: e.target.value,
                  gamekw: "",
                  classifyId: "",
                  type: 2,
                });
                if (e.target.value != "") {
                  isShow = false;
                  setIsShow(false);
                } else {
                  isShow = true;
                  setIsShow(true);
                }
              }}
              enterKeyHint="search"
              onKeyDown={handleKeyDown}
            />
          </div>

          {query.boardkw || query.gamekw ? (
            <CloseOutlined
              className="close"
              onClick={() => {
                setQuery({ boardkw: "", gamekw: "", classifyId: "", type: 2 });
                isShow = true;
                setIsShow(true);

                $("html,body").animate({ scrollTop: 0 }, 300);
              }}
            />
          ) : null}
        </div>

        <div className="search-index-input-right">
          <div className="line"></div>
          <div className="search-index-btn" onClick={btnClickSearch}>
            搜索
          </div>
        </div>
      </div>
    );
  }, [query.boardkw, kws, query.gamekw]);

  const [gameList, setGameList] = useState([]);
  useEffect(() => {
    Dialog.loading();
    general.axios
      .post("/v3/base/game/getGameList", {
        type: 2,
        pagination: { page: 1 },
      })
      .finally(() => {
        Dialog.close();
      })
      .then((res) => {
        console.log("热玩榜前五", res);
        let { status, data } = res.data;
        if (!status.succeed) {
          return;
        }

        let list = data.game_list.splice(0, 10).map((item) => {
          return {
            ...item,
            game_classify_type: item.game_classify_type
              .split(" ")
              .filter((item) => item != "")
              .slice(0, 2)
              .join(" "),
          };
        });
        setGameList(list);
      })
      .catch((err) => {
        // Dialog.error('search ' + err.message);
      });
  }, []);

  const [historySearch, setHistorySearch] = useState([]);
  useEffect(() => {
    let history = localStorage.getItem("search-page-history");
    if (history) {
      setHistorySearch(JSON.parse(history));
    }
  }, []);

  return (
    <>
      <div className="search-index">
        <Cover
          active={active && (!!query.boardkw || !!query.gamekw)}
          boardkw={query.boardkw}
          setBoardkw={(boardkw) => setQuery((prev) => ({ ...prev, boardkw }))}
          gamekw={query.gamekw}
          setGamekw={(gamekw) => setQuery((prev) => ({ ...prev, gamekw }))}
          type={query.type}
          setType={(type) => setQuery((prev) => ({ ...prev, type }))}
          kws={kws}
          gameList={gameList}
          setIsShow={(isShow) => setIsShow(isShow)}
          setSwiperIndex={(swiperIndex) => setSwiperIndex(swiperIndex)}
          historySearch={historySearch}
          setHistorySearch={(historySearch) => setHistorySearch(historySearch)}
        />

        <Result
          active={active && (!!query.boardkw || !!query.gamekw)}
          boardkw={query.boardkw}
          setBoardkw={(boardkw) => setQuery((prev) => ({ ...prev, boardkw }))}
          gamekw={query.gamekw}
          setGamekw={(gamekw) => setQuery((prev) => ({ ...prev, gamekw }))}
          classifyId={query.classifyId}
          setClassifyId={(classifyId) =>
            setQuery((prev) => ({ ...prev, classifyId }))
          }
          type={query.type}
          setType={(type) => setQuery((prev) => ({ ...prev, type }))}
          refresh={refresh}
          gameList={gameList.slice(0, 5)}
          historySearch={historySearch}
          setHistorySearch={(historySearch) => setHistorySearch(historySearch)}
        />
      </div>
    </>
  );
};
